import { Checkbox } from '@nazka/nazka.mapframe.components';

import LayerGroup from './LayerGroup/LayerGroup';

import './layer-selector.css';

function LayerSelector({
  title,
  groups = [],
  singularLayers = [],
  className = '',
}) {
  return (
    <div className={`layer-selector${className ? ` ${className}` : ''}`}>
      {title && <div className="layer-selector__title">{title}</div>}
      <div className="layer-selector__content">
        {groups.map((group, index) => (
          <LayerGroup
            key={index}
            title={group.title}
            layers={group.layers}
            selectedLayer={group.selectedLayer}
            onChange={group.onChange}
            startOpen={group.startOpen}
            collapsible={group.collapsible}
          />
        ))}
        {singularLayers.map(layer => (
          <div className="layer-selector__layer" key={layer.id}>
            <Checkbox
              className="layer-selector__layer__checkbox"
              id={layer.id}
              label={layer.label}
              checked={layer.checked}
              onInputChange={layer.onChange}
            />
          </div>
        ))}
      </div>
    </div>
  );
}

export default LayerSelector;
